import axios from "../../axios";

import * as apis from "../../apis";
import * as errors from "../../errors";

import history from "../../history";

import {notifyError, notifySuccess} from "../../toast-notifications";

import {
    ORDER_CONTACT_STEP, ORDER_SHIFT_STEP, goToOrderStep, ORDER_CHECKOUT_STEP, ORDER_CONFIRM_STEP,
    ORDER_UPON_PICKUP_PAYMENT_STEP
} from "./ui";

import {changeFormField} from "../../helpers";
import * as successes from "../../successes";

export const ORDER_DISTANCE_TOO_FAR = "ORDER_DISTANCE_TOO_FAR"
export const UNCAUGHT_ORDER_DISTANCE_ERROR = "UNCAUGHT_ORDER_DISTANCE_ERROR"
export const ORDER_DOES_NOT_EXIST_ERROR = "ORDER_DOES_NOT_EXIST_ERROR"
export const ORDER_CANCEL_IS_PASSED = "ORDER_CANCEL_IS_PASSED"

export const getInitOrderForm = () => {
    return {
        first_name: {value: "", modified: false, type: "name", valid: false},
        last_name: {value: "", modified: false, type: "name", valid: false},
        phone: {value: "", modified: false, type: "phone", valid: false},
        email: {value: "", modified: false, type: "email", valid: false},
        street: {value: "", modified: false, type: "street", valid: false},
        number: {value: "", modified: false, type: "street_number", valid: false},
        city: {value: "", modified: false, type: "city", valid: false},
        zip_code: {value: "", modified: false, type: "zip_code", valid: false},
        country: {value: "BE", modified: false, type: "country", valid: true},
        delivery: {value: false, modified: false, type: "boolean", valid: true},
        accept_adds: {value: false, modified: false, type: "boolean", valid: true},
        gdpr: {value: false, modified: false, type: "gdpr", valid: false},
    }
};

export const formToOrder = (form, cart, shift_from_datetime, shift_to_datetime) => {
    return {
        first_name: form.first_name.value,
        last_name: form.last_name.value,
        email: form.email.value,
        phone: form.phone.value,
        street: form.street.value,
        street_number: form.number.value,
        city: form.city.value,
        zip_code: form.zip_code.value,
        country: form.country.value,
        delivery: form.delivery.value,
        accept_adds: form.accept_adds.value,
        cart: cart,
        shift_from_datetime: shift_from_datetime,
        shift_to_datetime: shift_to_datetime,
    };
}

// RESET ORDER
export const RESET_ORDER = "RESET_ORDER"

// BLOCK_DELIVERY
export const BLOCK_DELIVERY = "BLOCK_DELIVERY"

// UPDATE ORDER SELECTED SHIFT
export const UPDATE_ORDER_SELECTED_SHIFT = "UPDATE_ORDER_SELECTED_SHIFT";

export const updateOrderSelectedShift = (shiftId) => {
    return dispatch => {
        dispatch({type: UPDATE_ORDER_SELECTED_SHIFT, orderSelectedShift: shiftId});
    }
};

// UPDATE ORDER SELECTED DATE
export const UPDATE_ORDER_SELECTED_DATE = "UPDATE_ORDER_SELECTED_DATE";

export const updateOrderSelectedDate = (date) => {
    return dispatch => {
        dispatch({type: UPDATE_ORDER_SELECTED_DATE, orderSelectedDate: date});
    }
};

// UPDATE CART
export const UPDATE_CART = "UPDATE_CART";

export const updateCart = (productId, value, dateId, date) => {
    return (dispatch, getState) => {
        const currentCart = getState().orderReducer.cart;
        const getCartProduct = currentCart.find(item => item.id === productId);

        dispatch(updateOrderSelectedDate(null));
        dispatch(updateOrderSelectedShift(null));

        const newCart = getCartProduct && value === 0 ?
            currentCart.filter(item => item.id !== productId) :
            [...currentCart.filter(item => item.id !== productId)].concat([{id: productId, quantity: value, dateId: dateId, date: date}])

        dispatch({type: UPDATE_CART, cart: newCart});
    }
};

// CHANGE ORDER FORM
export const CHANGE_ORDER_FORM = "CHANGE_ORDER_FORM";

export const changeOrderForm = (e, { name, value, checked }) => {
    return (dispatch, getState) => {
        const currentForm = getState().orderReducer.form;
        if (["accept_adds", "gdpr"].includes(name)) {
            value = checked;
        }
        if (["delivery"].includes(name)) {
            if(value === "true") {
                value = true;
            }
            else {
                value = false;
            }
        }
        let newForm = changeFormField(currentForm, name, value);
        dispatch({type: CHANGE_ORDER_FORM, form: newForm});
    }
};

// CONFIRM ORDER
export const CONFIRM_ORDER_REQUEST = "CONFIRM_ORDER_REQUEST";
export const CONFIRM_ORDER_SUCCESS = "CONFIRM_ORDER_SUCCESS";
export const CONFIRM_ORDER_ERROR = "CONFIRM_ORDER_ERROR";

export const confirmOrderRequest = () => {
    return {
        type: CONFIRM_ORDER_REQUEST,
        loading: true
    };
};
export const confirmOrderSuccess = (current_order) => {
    return {
        type: CONFIRM_ORDER_SUCCESS,
        loading: false,
        error: null,
        current_order
    };
};
export const confirmOrderError = (error) => {
    return {
        type: CONFIRM_ORDER_ERROR,
        loading: false,
        error
    };
};
export const confirmOrder = () => {
    return (dispatch, getState) => {
        dispatch(confirmOrderRequest());
        const form = getState().orderReducer.form;
        const cart = getState().orderReducer.cart;
        const shiftId = getState().orderReducer.orderSelectedShift;
        const shift = getState().orderReducer.virtualShifts.find(curr_shift => curr_shift.id === shiftId)
        const from_hour = shift.from_hour;
        const to_hour = shift.to_hour;
        const date = getState().orderReducer.orderSelectedDate;
        const shift_from_datetime = date + " " + from_hour; //moment(date + " " + from_hour, "YYYY-MM-DD HH:mm:ss")
        const shift_to_datetime = date + " " + to_hour; //moment(date + " " + to_hour, "YYYY-MM-DD HH:mm:ss")
        const onlinePaymentActive = getState().orderReducer.orderSettings.online_payment_active;
        const onlinePaymentEnabled = getState().orderReducer.orderSettings.online_payment_enabled;
        const uponPickupPaymentActive = getState().orderReducer.orderSettings.upon_pickup_payment_active;
        const order = formToOrder(form, cart, shift_from_datetime, shift_to_datetime);
        axios.post(apis.CONFIRM_ORDER_API, order)
            .then(response => {
                dispatch(confirmOrderSuccess(response.data));
                if ((!onlinePaymentEnabled || !onlinePaymentActive) && uponPickupPaymentActive) {
                    dispatch(goToOrderStep(ORDER_UPON_PICKUP_PAYMENT_STEP));
                }
                else {
                    dispatch(goToOrderStep(ORDER_CHECKOUT_STEP));
                }
            })
            .catch(error => {
                if (error.response.data) {
                    const message = error.response.data.message;
                    if (message === ORDER_DISTANCE_TOO_FAR) {
                        dispatch(confirmOrderError(ORDER_DISTANCE_TOO_FAR));
                        dispatch(goToOrderStep(ORDER_SHIFT_STEP));
                        dispatch(updateOrderSelectedDate(null));
                        dispatch(updateOrderSelectedShift(null));
                        dispatch(changeOrderForm(null, {name: "delivery", value: "false"}));
                    }
                    else if (message === UNCAUGHT_ORDER_DISTANCE_ERROR) {
                        dispatch(confirmOrderError(UNCAUGHT_ORDER_DISTANCE_ERROR));
                        dispatch(goToOrderStep(ORDER_CONTACT_STEP));
                    }
                    else {
                        notifyError(errors.CONFIRM_ORDER_ERROR);
                        dispatch(confirmOrderError(CONFIRM_ORDER_ERROR));
                    }
                }
                else {
                    notifyError(errors.CONFIRM_ORDER_ERROR);
                    dispatch(confirmOrderError(CONFIRM_ORDER_ERROR));
                }
            });
    };
};

// GET ORDER SETTINGS
export const GET_ORDER_SETTINGS_REQUEST = "GET_ORDER_SETTINGS_REQUEST";
export const GET_ORDER_SETTINGS_SUCCESS = "GET_ORDER_SETTINGS_SUCCESS";
export const GET_ORDER_SETTINGS_ERROR = "GET_ORDER_SETTINGS_ERROR";

export const getOrderSettingsRequest = () => {
    return {
        type: GET_ORDER_SETTINGS_REQUEST,
        loading: true
    };
};
export const getOrderSettingsSuccess = (orderSettings) => {
    return {
        type: GET_ORDER_SETTINGS_SUCCESS,
        loading: false,
        error: null,
        orderSettings
    };
};
export const getOrderSettingsError = (error) => {
    return {
        type: GET_ORDER_SETTINGS_ERROR,
        loading: false,
        error
    };
};
export const getOrderSettings = () => {
    return dispatch => {
        dispatch(getOrderSettingsRequest());
        axios.get(apis.GET_ORDER_SETTINGS_API)
            .then(response => {
                dispatch(getOrderSettingsSuccess(response.data));
            })
            .catch(error => {
                dispatch(getOrderSettingsError());
                notifyError(errors.GET_ORDER_SETTINGS_ERROR);
            });
    };
};

// CREATE PAYMENT INTENT
export const CREATE_PAYMENT_INTENT_REQUEST = "CREATE_PAYMENT_INTENT_REQUEST";
export const CREATE_PAYMENT_INTENT_SUCCESS = "CREATE_PAYMENT_INTENT_SUCCESS";
export const CREATE_PAYMENT_INTENT_ERROR = "CREATE_PAYMENT_INTENT_ERROR";

export const createPaymentIntentRequest = () => {
    return {
        type: CREATE_PAYMENT_INTENT_REQUEST,
        loading: true
    };
};
export const createPaymentIntentSuccess = (paymentIntentClientSecret) => {
    return {
        type: CREATE_PAYMENT_INTENT_SUCCESS,
        loading: false,
        error: null,
        paymentIntentClientSecret: paymentIntentClientSecret
    };
};
export const createPaymentIntentError = (error) => {
    return {
        type: CREATE_PAYMENT_INTENT_ERROR,
        loading: false,
        error
    };
};
export const createPaymentIntent = (token) => {
    return dispatch => {
        dispatch(createPaymentIntentRequest());
        const data = {token: token}
        axios.post(apis.CREATE_PAYMENT_INTENT_API, data)
            .then(response => {
                dispatch(createPaymentIntentSuccess(response.data.client_secret));
            })
            .catch(error => {
                dispatch(createPaymentIntentError());
                notifyError(errors.CREATE_PAYMENT_INTENT_ERROR);
            });
    };
};

// CREATE PAYMENT SOURCE
export const CREATE_PAYMENT_SOURCE_REQUEST = "CREATE_PAYMENT_SOURCE_REQUEST";
export const CREATE_PAYMENT_SOURCE_SUCCESS = "CREATE_PAYMENT_SOURCE_SUCCESS";
export const CREATE_PAYMENT_SOURCE_ERROR = "CREATE_PAYMENT_SOURCE_ERROR";

export const createPaymentSourceRequest = () => {
    return {
        type: CREATE_PAYMENT_SOURCE_REQUEST,
        loading: true
    };
};
export const createPaymentSourceSuccess = () => {
    return {
        type: CREATE_PAYMENT_SOURCE_SUCCESS,
        loading: false,
        error: null,
    };
};
export const createPaymentSourceError = (error) => {
    return {
        type: CREATE_PAYMENT_SOURCE_ERROR,
        loading: false,
        error
    };
};
export const createPaymentSource = (token, fullName) => {
    return dispatch => {
        dispatch(createPaymentSourceRequest());
        const data = {token: token, full_name: fullName};
        axios.post(apis.CREATE_PAYMENT_SOURCE_API, data)
            .then(response => {
                window.location.replace(response.data.redirect.url);
                dispatch(createPaymentSourceSuccess());
            })
            .catch(error => {
                dispatch(createPaymentSourceError());
                notifyError(errors.CREATE_PAYMENT_SOURCE_ERROR);
            });
    };
};


// CREATE UPON PICKUP PAYMENT
export const CREATE_UPON_PICKUP_PAYMENT_REQUEST = "CREATE_UPON_PICKUP_PAYMENT_REQUEST";
export const CREATE_UPON_PICKUP_PAYMENT_SUCCESS = "CREATE_UPON_PICKUP_PAYMENT_SUCCESS";
export const CREATE_UPON_PICKUP_PAYMENT_ERROR = "CREATE_UPON_PICKUP_PAYMENT_ERROR";

export const createUponPickupPaymentRequest = () => {
    return {
        type: CREATE_UPON_PICKUP_PAYMENT_REQUEST,
        loading: true
    };
};
export const createUponPickupPaymentSuccess = () => {
    return {
        type: CREATE_UPON_PICKUP_PAYMENT_SUCCESS,
        loading: false,
        error: null,
    };
};
export const createUponPickupPaymentError = (error) => {
    return {
        type: CREATE_UPON_PICKUP_PAYMENT_ERROR,
        loading: false,
        error
    };
};
export const createUponPickupPayment = (token) => {
    return dispatch => {
        dispatch(createUponPickupPaymentRequest());
        const data = {token: token};
        axios.post(apis.CREATE_UPON_PICKUP_PAYMENT_API, data)
            .then(response => {
                history.push("/shop/upon-pickup-redirect");
                dispatch(createUponPickupPaymentSuccess());
            })
            .catch(error => {
                dispatch(createUponPickupPaymentError());
                notifyError(errors.CREATE_UPON_PICKUP_PAYMENT_ERROR);
            });
    };
};

// Check distance
export const CHECK_DISTANCE_REQUEST = "CHECK_DISTANCE_REQUEST";
export const CHECK_DISTANCE_SUCCESS = "CHECK_DISTANCE_SUCCESS";
export const CHECK_DISTANCE_ERROR = "CHECK_DISTANCE_ERROR";

export const checkDistanceRequest = () => {
    return {
        type: CHECK_DISTANCE_REQUEST,
        loading: true
    };
};
export const checkDistanceSuccess = () => {
    return {
        type: CHECK_DISTANCE_SUCCESS,
        loading: false,
        error: null
    };
};
export const checkDistanceError = (error) => {
    return {
        type: CHECK_DISTANCE_ERROR,
        loading: false,
        error
    };
};
export const checkDistance = (destination) => {
    return dispatch => {
        dispatch(checkDistanceRequest());
        axios.post(apis.CHECK_DISTANCE_API, destination)
            .then(response => {
                dispatch(checkDistanceSuccess());
                dispatch(goToOrderStep(ORDER_CONFIRM_STEP));
            })
            .catch(error => {
                if (error.response.data) {
                    const message = error.response.data.message;
                    if (message === ORDER_DISTANCE_TOO_FAR) {
                        dispatch(checkDistanceError(ORDER_DISTANCE_TOO_FAR));
                        dispatch(goToOrderStep(ORDER_SHIFT_STEP));
                        dispatch(updateOrderSelectedDate(null));
                        dispatch(updateOrderSelectedShift(null));
                        dispatch(changeOrderForm(null, {name: "delivery", value: "false"}));
                    }
                    else if (message === UNCAUGHT_ORDER_DISTANCE_ERROR) {
                        dispatch(checkDistanceError(UNCAUGHT_ORDER_DISTANCE_ERROR));
                        dispatch(goToOrderStep(ORDER_CONTACT_STEP));
                    }
                    else {
                        notifyError(errors.CHECK_DISTANCE_ERROR);
                        dispatch(checkDistanceError(CHECK_DISTANCE_ERROR));
                    }
                }
                else {
                    notifyError(errors.CHECK_DISTANCE_ERROR);
                    dispatch(checkDistanceError(CHECK_DISTANCE_ERROR));
                }
            });
    };
};

// GET CURRENT ORDER
export const GET_CURRENT_ORDER_REQUEST = "GET_CURRENT_ORDER_REQUEST";
export const GET_CURRENT_ORDER_SUCCESS = "GET_CURRENT_ORDER_SUCCESS";
export const GET_CURRENT_ORDER_ERROR = "GET_CURRENT_ORDER_ERROR";

export const getCurrentOrderRequest = () => {
    return {
        type: GET_CURRENT_ORDER_REQUEST,
        loading: true
    };
};
export const getCurrentOrderSuccess = (order) => {
    return {
        type: GET_CURRENT_ORDER_SUCCESS,
        loading: false,
        error: null,
        order
    };
};
export const getCurrentOrderError = (error) => {
    return {
        type: GET_CURRENT_ORDER_ERROR,
        loading: false,
        error
    };
};
export const getCurrentOrder = (last_name, token) => {
    return dispatch => {
        dispatch(getCurrentOrderRequest());
        const data = {
            last_name: last_name,
            token: token
        }
        axios.post(apis.GET_CURRENT_ORDER_API, data)
            .then(response => {
                dispatch(getCurrentOrderSuccess(response.data));
            })
            .catch(error => {
                if (error.response) {
                    if (error.response.data.message === ORDER_DOES_NOT_EXIST_ERROR) {
                        dispatch(getCurrentOrderError(ORDER_DOES_NOT_EXIST_ERROR));
                    }
                    else if (error.response.data.message === ORDER_CANCEL_IS_PASSED){
                        dispatch(getCurrentOrderError(ORDER_CANCEL_IS_PASSED));
                    }
                    else {
                        dispatch(getCurrentOrderError(errors.GET_CURRENT_ORDER_ERROR));
                        notifyError(errors.GET_CURRENT_ORDER_ERROR);
                    }
                }
                else {
                    dispatch(getCurrentOrderError(errors.GET_CURRENT_ORDER_ERROR));
                    notifyError(errors.GET_CURRENT_ORDER_ERROR);
                }
            });
    };
};

// CANCEL ORDER
export const CANCEL_ORDER_REQUEST = "CANCEL_ORDER_REQUEST";
export const CANCEL_ORDER_SUCCESS = "CANCEL_ORDER_SUCCESS";
export const CANCEL_ORDER_ERROR = "CANCEL_ORDER_ERROR";

export const cancelOrderRequest = () => {
    return {
        type: CANCEL_ORDER_REQUEST,
        loading: true
    };
};
export const cancelOrderSuccess = () => {
    return {
        type: CANCEL_ORDER_SUCCESS,
        loading: false,
        error: null
    };
};
export const cancelOrderError = (error) => {
    return {
        type: CANCEL_ORDER_ERROR,
        loading: false,
        error
    };
};
export const cancelOrder = () => {
    return (dispatch, getState) => {
        dispatch(cancelOrderRequest());
        const currentOrder = getState().orderReducer.currentOrderSummary;
        const data = {
            last_name: currentOrder.last_name,
            token: currentOrder.token
        }
        axios.post(apis.CANCEL_ORDER_API, data)
            .then(response => {
                dispatch(cancelOrderSuccess());
                dispatch(getCurrentOrder(currentOrder.last_name, currentOrder.token))
                notifySuccess(successes.CANCEL_ORDER_SUCCESS)
            })
            .catch(error => {
                dispatch(cancelOrderError(errors.CANCEL_ORDER_ERROR));
                notifyError(errors.CANCEL_ORDER_ERROR);
            });
    };
};


// WEBPACK FOOTER //
// ./src/store/actions/order.js